import React from "react";
import SubjectRegistry from "../components/SubjectRegistry";

const FIELDS = [
  { key: "legal_name", label: "s.legal_name", required: true },
  { key: "tax_id", label: "s.tax_id" },
  { key: "country", label: "s.country", type: "country" },
  { key: "economic_sector", label: "s.economic_sector" },
  { key: "contact", label: "s.contact" },
  { key: "phone", label: "s.phone" },
  { key: "email", label: "s.email", type: "email" },
];

export default function Suppliers() {
  return <SubjectRegistry kind="supplier" titleKey="k.suppliers" subKey="k.suppliers_sub" addKey="k.new_supplier" fields={FIELDS} testid="suppliers" />;
}
